import { render } from "./Help.vue?vue&type=template&id=4b7595c0"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
script.render = render

export default script